var map = {
	"./anthemmr/back.jpg": 348,
	"./avemariamaster/back.jpg": 349,
	"./creekhavenlife/back.jpg": 152,
	"./current/back.jpg": 152,
	"./teravalis/back.jpg": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;